<template>
  <div :class="{ divider: true, 'divider-danger': isDanger }" :id="id">
    {{ title }}
  </div>
</template>

<script>
import globalBus from '../../../util/globalBus'
export default {
  props: ['value', 'id', 'stress'],
  data() {
    return {
      title: '',
      isDanger: this.stress,
    }
  },
  created() {
    const str = this.value
    if (str.indexOf('sw-form-div-line-blue') > -1 || str.indexOf('&lt;') > -1) {
      this.title = this.entityToString(str)
    } else {
      this.title = this.value
    }
    this.$watch('value', newVal => {
      this.title = newVal
    })
    globalBus.$on('toggleDividerState', data => {
      if (data.value !== this.title) {
        return
      }
      if (data.type === 'danger') {
        this.isDanger = true
      } else {
        this.isDanger = false
      }
    })
  },
  mounted() {
    window.navBus &&
      window.navBus.$emit('addNav', { value: this.value, id: this.id })
  },
  destroyed() {
    window.navBus &&
      window.navBus.$emit('sliceNav', { value: this.value, id: this.id })
  },
  methods: {
    entityToString(entity) {
      const div = document.createElement('div')
      div.innerHTML = entity
      const res = div.innerText || div.textContent
      return res
    },
  },
}
</script>

<style scoped>
.divider {
  position: relative;
  padding: 20px 12px;
  margin-bottom: 30px;
  border-bottom: 1px solid #e6e6e6;
  font-family:
    PingFangSC-Regular,
    PingFang SC;
  font-weight: 400;
  color: rgba(31, 32, 33, 1);
  line-height: 18px;
  font-size: 18px;
  text-align: left;
}

.divider::before {
  position: absolute;
  display: inline-block;
  background: #3394e1;
  border-radius: 2px;
  left: 0px;
  top: 20px;
  width: 4px;
  height: 18px;
  font-size: 18px;
  content: '';
}
.divider-danger {
  padding-left: 26px;
  background: #fb5a5b;
  color: #fff;
}
.divider-danger::before {
  background: #fff;
  left: 6px;
}
</style>
